<nimbus-filter-summary-button
  cdkOverlayOrigin
  #origin="cdkOverlayOrigin"
  [summary]="summary"
  [filterName]="filter.name"
  [disabled]="disabled"
  [isValueEmpty]="isValueEmpty"
  (summaryClick)="onSummaryClick()"
  (removeFilter)="onRemoveFilter()"
></nimbus-filter-summary-button>

<ng-template
  cdkConnectedOverlay
  #overlay="cdkConnectedOverlay"
  cdkConnectedOverlayPanelClass="nimbus-filter-select-connected-overlay"
  [cdkConnectedOverlayHasBackdrop]="false"
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayPositions]="cdkConnectedPositions"
  [cdkConnectedOverlayOpen]="isOpen$ | async"
  (detach)="onDetach()"
  (attach)="onAttach(overlay)"
  (overlayOutsideClick)="onOutsideClick($event)"
>
  <div #filterOverlay class="nimbus-tooltip-complex flex-container tooltip-content">
    <nimbus-filter-search-list
      [optionsFn]="filter.options$"
      [focusable]="false"
      [selectedOptions]="selectedValues"
      (selectionChanged)="onSelectionChanged($event)"
    ></nimbus-filter-search-list>
  </div>
</ng-template>
